import React, { Component } from 'react';
import axios from 'axios';
import {API_URL} from '../../../constants';
import Error from '../../../components/Error/error';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import cookie from 'react-cookies';
import {approveRole} from '../../../functions';
import Moment from 'moment';
import {DropDownList} from '../../Elements/Select/dropdown';
import ResourcePagination from '../../Elements/Pagination/resourcepagination';
import $ from "jquery";
import { Pagination } from '../../Elements/Pagination/tablePagination';

function Estado(key){
    switch(key){
        case "R": return <span className="label label-primary">BORRADOR</span>;
        case "A": return <span className="label label-default">TERMINADO</span>;
        case "P": return <span className="label label-info" style={{background: "#44AA44"}}>APROBADO</span>;
        default:
            break;
    }
}

export default class Recurso extends Component {

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({ nTipoRecursoCodigo: value });
        console.log(value);
    }

    handleInputTextChange(event){
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        this.setState({ sTitulo: ((value==='') ? ('ALL') : (value))});
    }

    constructor (props){
        super(props);
        this.state = {
            resource:               [],
            response:               [],
            optionsTipoRecurso:     [],
            error:                  [],
            security:               cookie.load('user'),
            menu:                   localStorage.getItem("usermenu"),
            roles:                  [],
            nTipoRecursoCodigo :    '0',
            sTitulo :               'ALL'
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputTextChange = this.handleInputTextChange.bind(this);
    }

    editResource(id){
        
        this.props.history.push({
            pathname: '/edit-recurso/' + id,
            state: { key: id }
          });
    }

    addResource(){
        this.props.history.push({
            pathname: '/add-recurso/',
            state: { key: 0}
          });
    }

    searchResource(page = '1', search = "ALL"){

        if(search === "" || search === null){
            search = "ALL";
        }

        const menu          = JSON.parse(this.state.menu);
        const roleRecursos  = menu.find(itemmenu => itemmenu.sAgrupador === 'Recursos');

        const isAdminRecursos = roleRecursos ? roleRecursos.sMenu.find(itemRole => itemRole.sOpcNombre === "Gestor de Recursos") : null;
        
        /*
            console.log('MENU', menu);
            console.log('Role', roleRecursos);
            console.log('isAdminRecursos', isAdminRecursos);
            const rolUsuario    = usuario.cRolesxUsuario[0].nRolCodigo;
        */

        var usuario         = this.state.security;
        let codUsuario      = (isAdminRecursos) ? 0 : usuario.nUsuCodigo;

        console.log('USUARIO', usuario, codUsuario);
        const url = `${API_URL}ResourceUX/${page}/X/${codUsuario}/0/0/${search}`;
        
        axios.get(url).then(response => response.data)
        .then((data) => {

            // Toast result length
            if (search != "ALL"){
                if(data.result.length > 0){
                    toast.success(`Se han encontrado ${data.result.length} resultados`)
                }else{
                    toast.error("No se encontraron resultados para la busqueda")
                } 
            }

            this.setState({ 
                resource: data.result, 
                response: data, 
                error: data.Error,
                pagina: page 
            }, () => {
                document.querySelector('.loader').classList.add('loader--hide');
                document.getElementById('content-wrapper').removeAttribute("hidden");
            });

        }).catch(error => {
            //document.querySelector('.loader').classList.add('loader--hide');
            toast.error('Error de comunicación');
        });
    }

    componentDidMount(){
        
        var flag = localStorage.getItem("load");

        if (flag===false) {
            window.location.reload();
            localStorage.setItem("load", true);
        }

        if (localStorage.getItem("load")===null || flag==="false") {
            window.location.reload();
            localStorage.setItem("load", true);
        }

        //document.getElementById('containerPanel').style='display:none';
        $(".divContenidoPanelNav").animate({"left": "-510px"});
        this.searchResource();
    }

    render() {

        Moment.updateLocale('en', {
            months : [
                "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio",
                "Agosto", "Setiembre", "Octubre", "Noviembre", "Diciembre"
            ]
        });

        Moment.updateLocale('en', {
            weekdays : [
                "Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"
            ]
        });

        return (
            this.state.response.statusCode == 200 ?
            
                <div id="detailBody" className="Site-content" >
                    <div className="loader"></div>
                    <div hidden={true} id="content-wrapper" className="d-flex flex-column">
                        <div id="content">
                            <div id="Body" className="body-container container-fluid">
                                <div className="content-option col-sm-12 col-lg-11 mx-auto" >
                                    <div className="row recursos__search section__margin-bottom">
                                        <div className="col-sm-12">
                                            <div className="ibox-content">
                                                    <div className="search-form">
                                                        <div className="input-group">
                                                            <i className="recursos__search-icon fas fa-search"></i>
                                                            <input type="text" placeholder="NOMBRE DEL RECURSO" onChange={this.handleInputTextChange} name="search" className="recursos__search-form-control form-control input-lg" />
                                                            <div className="input-group-btn col-sm-4">
                                                                <DropDownList metodo={"add"} valor={0}  name="nTipoRecursoCodigo" id="nTipoRecursoCodigo"  onChange={this.handleInputChange} componente={"TipoRecurso"} />
                                                            </div>
                                                            &nbsp;&nbsp;
                                                            <div className="input-group-btn">
                                                                <button className="btn btn-primary btn-primary__submit" onClick={() => this.searchResource("1", this.state.sTitulo)}  type="submit">
                                                                    <i className="fa fa-search" style={{ marginRight: "8px" }} />
                                                                    BUSCAR
                                                                </button>
                                                            </div>
                                                            &nbsp;&nbsp;
                                                            <div className="input-group-btn">
                                                                <button className="btn btn-success btn-primary__submit" onClick={() => this.addResource()} type="submit">
                                                                    <i className="fa fa-save" style={{ marginRight: "8px" }} />
                                                                    NUEVO
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="recursos__wrapper-table">
                                                <table id="recursos__table" className="table table-striped table-bordered" >
                                                    <thead>
                                                        <tr>
                                                            <th className="table-bordered-radius--left">CÓDIGO</th>
                                                            <th>TÍTULO DEL RECURSO</th>
                                                            <th>TIPO</th>
                                                            <th>FECHA CREACION</th>
                                                            <th>SECTOR</th>
                                                            <th>USUARIO</th>
                                                            <th className="text-center">ESTADO</th>
                                                            <th className="text-center">ACTIVO</th>
                                                            <th className="table-bordered-radius--right text-center">ACCIÓN</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    {this.state.resource.map((resource) => {
                                                        return <tr key={resource.nRecursoCodigo}>
                                                            <td>{resource.nRecursoCodigo}</td>
                                                            <td>{resource.sTitulo}</td>
                                                            <td>{resource.sDescripcionTipoRecurso}</td>
                                                            <td>{Moment(resource.dFechaCreacion).format('dddd DD, MMMM YYYY')}</td>
                                                            <td>{resource.sSector}</td>
                                                            <td>{resource.sUsuario}</td>
                                                            <td className="text-center">
                                                                {Estado(resource.cEstado)}
                                                            </td>
                                                            <td className="text-center">
                                                                {(resource.bActivo?<span className="label label-info">ACTIVO</span>:<span className="label label-warning">INACTIVO</span>)}
                                                            </td>
                                                            <td className="recursos__table-action-option">
                                                                <button onClick={() => this.editResource(resource.nRecursoCodigo)} className="btn btn-primary btn-primary__tool" type="button"><i className="fas fa-pen fa-sm"></i></button>
                                                            </td>
                                                        </tr>
                                                    })}
                                                    </tbody>
                                                </table>
                                                {this.state.resource.length > 0 &&
                                                    <Pagination
                                                        data={this.state.resource}
                                                        pagina={this.state.pagina}
                                                        changePage={(page) => this.searchResource(page, this.state.sTitulo)}
                                                    />  
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            
            :
                <Error StatusCode={this.state.response.StatusCode} StatusMessage={this.state.response.StatusMessage}></Error>
            
        );
    }
}
